// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1vU7o","right":"styles_right__3WsOd"};